const reducer = state => ({
  ...state,
  giftVoucherToRemove: null,
  waiting: false,
});

export default reducer;
